<button
  mat-mini-fab
  class="mat-mini-fab-map-control"
  [matTooltip]="'map.control_plotting_map.tooltip' | translate"
  matTooltipPosition="left"
  matTooltipShowDelay="500"
  (click)="openPlot()"
>
  <mat-icon>architecture</mat-icon>
</button>
